import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';

import { Constants } from "../models/constants";
import { ApptCreator, ApptCreationData } from './appt-creation-service'

@Injectable({ providedIn: 'root' })
export class NavParamsHistoryStore {

  constructor(
    private storage: Storage
  ) {}

  get(page: string, successCallback: (data: any) => void) {

    let name = this.storeName(page)

    this.storage.get(name).then((data: any) => {
      if (data) {
        console.log(data)
        successCallback(data)
      }
    });
  }

  getApptCreatorData(successCallback: (data: any) => void) {

    this.storage.get('apptCreatorData').then((data: any) => {
      console.log('apptCreatorData - get')
      console.log(data)
      if (data) {
        successCallback(data)
      }
    });
  }

  save(page: string, navParamsData: any, apptCreator?: ApptCreator) {

    let name = this.storeName(page)
    this.storage.set(name, navParamsData);

    if (apptCreator) {

      let apptCreatorData: ApptCreationData = {
        address: apptCreator.address,
        mainScreenSelectedWeek_number: apptCreator.mainScreenSelectedWeek.weekNumber,
        selectedServiceTypeListItems: apptCreator.selectedServiceTypeList.items,
        apptTime_Date: apptCreator.apptTime.date,
        apptTime_Timezone: apptCreator.apptTime.timezone,
        availID: apptCreator.availID,
        barber: apptCreator.barber,
        cost: apptCreator.cost,
        coupon: apptCreator.coupon,
        barberProfileNavHistory: apptCreator.barberProfileNavHistory,
        customAddressData: apptCreator.customAddressData,
      }

      console.log('apptCreatorData - save')
      console.log(apptCreatorData)

      this.storage.set('apptCreatorData', apptCreatorData);
    }

  }


  private storeName(page: string) {
    return 'navParamStore: ' + page
  }

}
